import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, NgZone, Service } from '@angular/core';
import { ConfirmationDialogComponent, ConfirmationDialogModel } from '@app/shared/confirmation-dialog/confirmation-dialog.component';
import { DialogConfig, DialogService } from '@app/core/services/dialog.service';

@Service({ autoProvided: false })
export class GlobalErrorHandler implements ErrorHandler {
  private readonly dialogService = inject(DialogService);
  private readonly zone = inject(NgZone);

  handleError(error: any) {
    if (!error) {
      // Handle undefined error
      this.showErrorDialog('Unerwarteter Fehler', 'Ein unbekannter Fehler ist aufgetreten');
      return;
    }

    if (error instanceof HttpErrorResponse) {
      const status = error.error?.status;
      const statusText = error.error?.error;
      this.showErrorDialog(`HTTP ${status} ${statusText}`, error.message ?? 'Unbekannter Client-Fehler');
    } else if (error.rejection) {
      this.showErrorDialog('Unerwarteter Fehler', error.rejection.message ?? JSON.stringify(error.rejection));
    } else {
      this.showErrorDialog('Unerwarteter Fehler', error.message ?? JSON.stringify(error));
    }

    // eslint-disable-next-line no-console
    console.error('Error from global error handler', error);
  }

  showErrorDialog(title: string, message: string) {
    // dialog opening in a callback of zone.run, so that the dialog window can be closed even if the error is thrown outside the ngZone
    this.zone.run(() => {
      const dialogConfig: DialogConfig = {
        data: {
          title,
          message,
          allowCancel: false,
          confirmText: 'Schließen',
        } satisfies ConfirmationDialogModel,
      } satisfies DialogConfig;
      this.dialogService.open(ConfirmationDialogComponent, dialogConfig);
    });
  }
}
